import React, { useState } from "react";
import { Modal, Button } from "olive-react-myoneui";

const ConfirmBox = (props) => {
  // console.log(props)
  const { show, onHide, onSubmit, question, id, buttonLoading } = props;

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        contentClassName="bg-transparent border-0"
      >
        <Modal.Header className="border-0">
          {question && <Modal.Title>{question}</Modal.Title>}
        </Modal.Header>
        <Modal.Footer className="border-0">
          <Button variant="glitter" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => onSubmit(id)}>
            {buttonLoading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ConfirmBox;
